import Facial from "./facial/facial_device.module";

export default {
  modules: {
    Facial,
  },
};
